export const TEMPLATE_REQUIREMENTS = {
  storyRtm: ["project", "issueTypes"],
  testRtm: ["project", "issueTypes"],
  defectAnalytics: ["project", "issueTypes"],
  executionRtm: ["project", "fixVersions"],
};

export const SETUP_STEPS = [
  {
    key: "template",
    label: "Template",
    required: true,
  },
  {
    key: "project",
    label: "Project",
    required: true,
  },
  {
    key: "issueTypes",
    label: "Issue Type",
    required: true,
  },
  {
    key: "fixVersions",
    label: "Fix Version",
    required: true,
  },
];